import React, { Component } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import "./App.css"
import { ThemeProvider } from "styled-components"
import theme from "./theme"
import UrlTest from "./UrlTest"
import ErrorMessage from "./ErrorMessage"
import Header from "./Header"
import domain from "./domain"
import OctoprintParser from "./OctoprintParser"
import WebsocketTest from "./websocketTest"

console.log(domain)
class App extends Component {
    constructor(props) {
        super(props)

        let servers = ["buildbee.com"]
        let domains_ = ["buildbee.com", "buildflow.online"]

        domains_.forEach(serverDomain => {
            servers.push(
                `app.${serverDomain}`,
                `heimdall.${serverDomain}`,
                `relay.${serverDomain}`,
                `download.${serverDomain}`,
                `gcode.${serverDomain}`,
                `server-builds.${serverDomain}`
            )
        })
        servers.push(
            "s3-ap-southeast-2.amazonaws.com/buildflowonlineapi-prod-modelstlbucket-z55nrciizxi1"
        )

        this.state = {
            error: false,
            wsError: false,
            resources: servers,
            websocketResources: ["elli.buildbee.com"],
            successes: [],
            wsStatus: null
        }
    }

    errorEncountered = () => {
        this.setState({ error: true })
    }

    websocketErrorEncountered = () => {
        this.setState({ wsError: true })
    }

    registerSuccess = () => {
        this.setState({ successes: [true, ...this.state.successes] })
    }

    deployTests = () =>
        this.state.resources.map(resource => (
            <UrlTest
                key={resource}
                resource={resource}
                successCallback={this.registerSuccess}
                errorCallback={this.errorEncountered}
            />
        ))

    deployWebsocketsTests = () =>
        this.state.websocketResources.map(resource => (
            <WebsocketTest
                key={resource}
                resource={resource}
                successCallback={this.registerSuccess}
                errorCallback={this.websocketErrorEncountered}
            />
        ))
    wsSuccess = () => this.setState({ wsStatus: true })
    wsFail = () => this.setState({ wsStatus: false })

    render() {
        return (
            <Router>
                <ThemeProvider theme={theme}>
                    <Switch>
                        <Route path="/logreader">
                            <OctoprintParser />
                        </Route>
                        <Route path="/">
                            <div className="App">
                                <Header />
                                <h2
                                    style={{
                                        width: "60%",
                                        marginLeft: "15%"
                                    }}
                                >
                                    HTTPS Resources
                                </h2>
                                {this.deployTests()}
                                <h2
                                    style={{
                                        width: "60%",
                                        marginLeft: "15%"
                                    }}
                                >
                                    WSS Resources
                                </h2>
                                {this.deployWebsocketsTests()}
                                <ErrorMessage
                                    error={this.state.error}
                                    wsError={this.state.wsError}
                                    count={this.state.resources.length}
                                    complete={this.state.successes.length}
                                    wsSuccess={this.wsSuccess}
                                    wsFail={this.wsFail}
                                    wsStatus={this.state.wsStatus}
                                />
                            </div>
                        </Route>
                    </Switch>
                </ThemeProvider>
            </Router>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js